import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db, auth, app } from '../../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getMessaging, getToken } from 'firebase/messaging';
import '../../styles/SettingPush.css';

const SettingPush = () => {
  const [user, loading, error] = useAuthState(auth);

  // 各トグルの状態を個別に管理
  const [isPushEnabled, setIsPushEnabled] = useState(false);
  const [isLikeEmailEnabled, setIsLikeEmailEnabled] = useState(false);
  const [isMatchEmailEnabled, setIsMatchEmailEnabled] = useState(false);
  const [isChatEmailEnabled, setIsChatEmailEnabled] = useState(false);

  useEffect(() => {
    const fetchPushSettings = async () => {
      if (user) {
        const docRef = doc(db, 'push_settings', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setIsPushEnabled(data.push || false);
          setIsLikeEmailEnabled(data.likeEmail || false);
          setIsMatchEmailEnabled(data.matchEmail || false);
          setIsChatEmailEnabled(data.chatEmail || false);
        }
      }
    };

    if (user) {
      fetchPushSettings();
    }
  }, [user]);

  const handleToggle = async (type, value) => {
    if (user) {
      const docRef = doc(db, 'push_settings', user.uid);
      const tokenRef = doc(db, 'tokens', user.uid);

      if (type === 'push') {
        setIsPushEnabled(value);
        await setDoc(tokenRef, { approve: value }, { merge: true });

        if (value === true) {
          const permission = await Notification.requestPermission();

          if (permission === 'granted') {
            try {
              const messaging = getMessaging(app);
              const registration = await navigator.serviceWorker.ready;

              const currentToken = await getToken(messaging, {
                vapidKey: 'BOQlFlynawoiv-mauechKpC6F0LKgUudbuzcfO80eqJhlIdDUqPKR-VVnw-cJ6j2lG3_lRqtuWztwIK0SflphQo',
                serviceWorkerRegistration: registration,
              });

              if (currentToken) {
                await setDoc(tokenRef, { token: currentToken }, { merge: true });
                console.log('Token updated successfully:', currentToken);
              } else {
                console.warn('No registration token available.');
              }
            } catch (error) {
              console.error('Failed to get token:', error);
            }
          } else {
            console.warn('Notification permission not granted');
          }
        } else {
          // OFFにしたときは token を null にする
          await setDoc(tokenRef, { token: null }, { merge: true });
        }
      }

      if (type === 'likeEmail') {
        await setDoc(tokenRef, { iine_mail: value }, { merge: true });
        setIsLikeEmailEnabled(value);
      } else if (type === 'matchEmail') {
        await setDoc(tokenRef, { match_mail: value }, { merge: true });
        setIsMatchEmailEnabled(value);
      } else if (type === 'chatEmail') {
        await setDoc(tokenRef, { chats_mail: value }, { merge: true });
        setIsChatEmailEnabled(value);
      }

      await setDoc(docRef, { [type]: value }, { merge: true });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="setting-push-container">
      <div className="header">
        <Link to="/settings" className="back-link-cont">←</Link>
        <p className="settings-title-cont">プッシュ通知設定</p>
      </div>
      <br /><br />
      <h3>通知設定</h3>
      <br />
      <div className="toggle-container">
        <span className="toggle-label">プッシュ通知</span>
        <label className="switch-a">
          <input
            type="checkbox"
            checked={isPushEnabled}
            onChange={() => handleToggle('push', !isPushEnabled)}
          />
          <span className="slider-a round"></span>
        </label>
      </div>
      <div className="toggle-container">
        <span className="toggle-label">いいね受信時のメール通知</span>
        <label className="switch-a">
          <input
            type="checkbox"
            checked={isLikeEmailEnabled}
            onChange={() => handleToggle('likeEmail', !isLikeEmailEnabled)}
          />
          <span className="slider-a round"></span>
        </label>
      </div>
      <div className="toggle-container">
        <span className="toggle-label">マッチング時のメール通知</span>
        <label className="switch-a">
          <input
            type="checkbox"
            checked={isMatchEmailEnabled}
            onChange={() => handleToggle('matchEmail', !isMatchEmailEnabled)}
          />
          <span className="slider-a round"></span>
        </label>
      </div>
      <div className="toggle-container">
        <span className="toggle-label">チャット受信時のメール通知</span>
        <label className="switch-a">
          <input
            type="checkbox"
            checked={isChatEmailEnabled}
            onChange={() => handleToggle('chatEmail', !isChatEmailEnabled)}
          />
          <span className="slider-a round"></span>
        </label>
      </div>
    </div>
  );
};

export default SettingPush;
